const normalizePermissionName = (name) => {
  if (!name) return '';
  return name
    .normalize('NFD')
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_+/g, '_')
    .toUpperCase();
};

const ADMIN_ALIASES = ['ADMINISTRADOR', 'ADMIN'];
const FORM_MANAGER_ALIASES = ['GERENCIAR_FORMULARIOS', 'MANAGE_FORMS'];
const REGISTRATION_MANAGER_ALIASES = ['GERENCIAR_CADASTROS', 'MANAGE_REGISTRATIONS'];
const REGISTRATION_VIEW_ALIASES = [
  'VISUALIZAR_CADASTROS',
  'VIEW_REGISTRATIONS',
  ...REGISTRATION_MANAGER_ALIASES,
];
const FINANCE_MANAGER_ALIASES = ['GERENCIAR_FINANCEIRO', 'MANAGE_FINANCE'];
const FINANCE_VIEW_ALIASES = [
  'VISUALIZAR_FINANCEIRO',
  'VIEW_FINANCE',
  ...FINANCE_MANAGER_ALIASES,
];
const INVENTORY_MANAGER_ALIASES = ['GERENCIAR_ESTOQUE', 'MANAGE_INVENTORY'];
const INVENTORY_VIEW_ALIASES = [
  'VISUALIZAR_ESTOQUE',
  'VIEW_INVENTORY',
  ...INVENTORY_MANAGER_ALIASES,
];

const CRM_MANAGER_ALIASES = ['GERENCIAR_CRM', 'MANAGE_CRM'];
const CRM_VIEW_ALIASES = ['VISUALIZAR_CRM', 'VIEW_CRM', ...CRM_MANAGER_ALIASES];

const HUMAN_RESOURCES_MANAGER_ALIASES = [
  'GERENCIAR_RECURSOS_HUMANOS',
  'GERENCIAR_RH',
  'MANAGE_HUMAN_RESOURCES',
  'MANAGE_HR',
];

const HUMAN_RESOURCES_VIEW_ALIASES = [
  'VISUALIZAR_RECURSOS_HUMANOS',
  'VISUALIZAR_RH',
  'VIEW_HUMAN_RESOURCES',
  'VIEW_HR',
  ...HUMAN_RESOURCES_MANAGER_ALIASES,
];

const ASSET_MANAGER_ALIASES = [
  'GERENCIAR_PATRIMONIO',
  'MANAGE_ASSETS',
  'GERENCIAR_ESTOQUE',
  'MANAGE_INVENTORY',
];
const ASSET_VIEW_ALIASES = [
  'VISUALIZAR_PATRIMONIO',
  'VIEW_ASSETS',
  'VISUALIZAR_ESTOQUE',
  'VIEW_INVENTORY',
  ...ASSET_MANAGER_ALIASES,
];

const MENU_PERMISSION_ALIASES = {
  VISUALIZAR_MENU_DASHBOARD: [
    'VISUALIZAR_MENU_DASHBOARD',
    'VIEW_MENU_DASHBOARD',
    'VIEW_DASHBOARD_MENU',
  ],
  VISUALIZAR_MENU_AUTOMACOES: [
    'VISUALIZAR_MENU_AUTOMACOES',
    'VIEW_MENU_AUTOMACOES',
    'VIEW_MENU_AUTOMATIONS',
    'VIEW_AUTOMATION_MENU',
  ],
  VISUALIZAR_MENU_SOLICITACOES: [
    'VISUALIZAR_MENU_SOLICITACOES',
    'VIEW_MENU_SOLICITACOES',
    'VIEW_MENU_REQUESTS',
  ],
  VISUALIZAR_MENU_STUDIO: [
    'VISUALIZAR_MENU_STUDIO',
    'VIEW_MENU_STUDIO',
  ],
  VISUALIZAR_MENU_CURSOS: [
    'VISUALIZAR_MENU_CURSOS',
    'VIEW_MENU_COURSES',
  ],
  VISUALIZAR_MENU_ASSISTENTE_IA: [
    'VISUALIZAR_MENU_ASSISTENTE_IA',
    'VIEW_MENU_ASSISTANT_AI',
    'VIEW_ASSISTANT_MENU',
  ],
  VISUALIZAR_MENU_FORMULARIOS: [
    'VISUALIZAR_MENU_FORMULARIOS',
    'VIEW_MENU_FORMS',
  ],
  VISUALIZAR_MENU_PROCESSOS: [
    'VISUALIZAR_MENU_PROCESSOS',
    'VIEW_MENU_PROCESSES',
  ],
  VISUALIZAR_MENU_ARQUIVOS: [
    'VISUALIZAR_MENU_ARQUIVOS',
    'VIEW_MENU_FILES',
  ],
  VISUALIZAR_MENU_AGENDA: [
    'VISUALIZAR_MENU_AGENDA',
    'VIEW_MENU_AGENDA',
    'VIEW_MENU_CALENDAR',
  ],
  VISUALIZAR_MENU_NEGOCIO: [
    'VISUALIZAR_MENU_NEGOCIO',
    'VIEW_MENU_BUSINESS',
  ],
  VISUALIZAR_MENU_CRM: [
    'VISUALIZAR_MENU_CRM',
    'VIEW_MENU_CRM',
  ],
  VISUALIZAR_MENU_CONFIGURACOES: [
    'VISUALIZAR_MENU_CONFIGURACOES',
    'VIEW_MENU_CONFIGURACOES',
    'VIEW_MENU_SETTINGS',
  ],
  VISUALIZAR_MENU_CADASTROS: [
    'VISUALIZAR_MENU_CADASTROS',
    'VISUALIZAR_MENU_CENTRAL_DE_CADASTROS',
    'VIEW_MENU_REGISTRATIONS',
    'VIEW_REGISTRATION_CENTER_MENU',
  ],
  VISUALIZAR_MENU_DADOS_CADASTRAIS: [
    'VISUALIZAR_MENU_DADOS_CADASTRAIS',
    'VIEW_MENU_COMPANY_PROFILE',
  ],
  VISUALIZAR_MENU_FINANCEIRO: [
    'VISUALIZAR_MENU_FINANCEIRO',
    'VIEW_MENU_FINANCE',
  ],
  VISUALIZAR_MENU_ESTOQUE: [
    'VISUALIZAR_MENU_ESTOQUE',
    'VIEW_MENU_INVENTORY',
  ],
  VISUALIZAR_MENU_PATRIMONIO: [
    'VISUALIZAR_MENU_PATRIMONIO',
    'VIEW_MENU_ASSETS',
  ],
  VISUALIZAR_MENU_RECURSOS_HUMANOS: [
    'VISUALIZAR_MENU_RECURSOS_HUMANOS',
    'VIEW_MENU_HUMAN_RESOURCES',
  ],
  VISUALIZAR_MENU_ORGANOGRAMA: [
    'VISUALIZAR_MENU_ORGANOGRAMA',
    'VIEW_MENU_ORGANOGRAM',
    'VIEW_MENU_ORG_CHART',
  ],
  VISUALIZAR_MENU_GRUPOS: [
    'VISUALIZAR_MENU_GRUPOS',
    'VIEW_MENU_GRUPOS',
    'VIEW_GROUPS_MENU',
  ],
  VISUALIZAR_MENU_USUARIOS: [
    'VISUALIZAR_MENU_USUARIOS',
    'VIEW_MENU_USUARIOS',
    'VIEW_USERS_MENU',
  ],
  VISUALIZAR_MENU_AUDITORIA: [
    'VISUALIZAR_MENU_AUDITORIA',
    'VIEW_MENU_AUDITORIA',
    'VIEW_AUDIT_MENU',
  ],
  VISUALIZAR_MENU_EMAIL: [
    'VISUALIZAR_MENU_EMAIL',
    'VIEW_MENU_EMAIL',
    'VIEW_MAIL_MENU',
  ],
  VISUALIZAR_MENU_MANUAL_DO_USUARIO: [
    'VISUALIZAR_MENU_MANUAL_DO_USUARIO',
    'VIEW_MENU_MANUAL_DO_USUARIO',
    'VIEW_USER_MANUAL_MENU',
  ],
  VISUALIZAR_MENU_PERFIL: [
    'VISUALIZAR_MENU_PERFIL',
    'VIEW_MENU_PERFIL',
    'VIEW_PROFILE_MENU',
  ],
  VISUALIZAR_MENU_MINHA_EQUIPE: [
    'VISUALIZAR_MENU_MINHA_EQUIPE',
    'VIEW_MENU_MINHA_EQUIPE',
    'VIEW_MY_TEAM_MENU',
  ],
  VISUALIZAR_MENU_LIXEIRA: [
    'VISUALIZAR_MENU_LIXEIRA',
    'VIEW_MENU_LIXEIRA',
    'VIEW_TRASH_MENU',
    'VIEW_MENU_TRASH',
  ],
};

const PERMISSION_ALIASES = {
  ADMINISTRADOR: ADMIN_ALIASES,
  GERENCIAR_EMPRESA: ['GERENCIAR_EMPRESA', 'MANAGE_COMPANY'],
  GERENCIAR_FORMULARIOS: FORM_MANAGER_ALIASES,
  GERENCIAR_CADASTROS: REGISTRATION_MANAGER_ALIASES,
  VISUALIZAR_CADASTROS: REGISTRATION_VIEW_ALIASES,
  VISUALIZAR_CURSOS: ['VISUALIZAR_CURSOS', 'VIEW_COURSES', 'ALUNO', 'CRIADOR_DE_CONTEUDO', 'GERENCIAR_CURSOS', 'PROFESSOR'],
  VISUALIZAR_EDICAO_CURSOS: ['VISUALIZAR_EDICAO_CURSOS', 'VIEW_COURSE_EDITOR', 'PROFESSOR'],
  GERENCIAR_CURSOS: ['GERENCIAR_CURSOS', 'MANAGE_COURSES', 'CRIADOR_DE_CONTEUDO', 'PROFESSOR'],
  CRIADOR_DE_CONTEUDO: ['CRIADOR_DE_CONTEUDO', 'CONTENT_CREATOR', 'GERENCIAR_CURSOS', 'PROFESSOR'],
  ALUNO: ['ALUNO', 'STUDENT', 'VISUALIZAR_CURSOS', 'VIEW_COURSES'],
  PROFESSOR: ['PROFESSOR', 'TEACHER', 'CRIADOR_DE_CONTEUDO', 'GERENCIAR_CURSOS'],
  COORDENADOR_DE_CURSOS: ['COORDENADOR_DE_CURSOS', 'COURSE_COORDINATOR', 'GERENCIAR_TURMAS'],
  GERENCIAR_TURMAS: ['GERENCIAR_TURMAS', 'MANAGE_COURSE_CLASSES', 'COORDENADOR_DE_CURSOS'],
  GERENCIAR_FINANCEIRO: FINANCE_MANAGER_ALIASES,
  VISUALIZAR_FINANCEIRO: FINANCE_VIEW_ALIASES,
  GERENCIAR_ESTOQUE: INVENTORY_MANAGER_ALIASES,
  VISUALIZAR_ESTOQUE: INVENTORY_VIEW_ALIASES,
  GERENCIAR_CRM: CRM_MANAGER_ALIASES,
  VISUALIZAR_CRM: CRM_VIEW_ALIASES,
  GERENCIAR_RECURSOS_HUMANOS: HUMAN_RESOURCES_MANAGER_ALIASES,
  VISUALIZAR_RECURSOS_HUMANOS: HUMAN_RESOURCES_VIEW_ALIASES,
  GERENCIAR_PATRIMONIO: ASSET_MANAGER_ALIASES,
  VISUALIZAR_PATRIMONIO: ASSET_VIEW_ALIASES,
  GERENCIAR_ARQUIVOS: ['GERENCIAR_ARQUIVOS', 'MANAGE_FILES'],
  GERENCIAR_PROCESSOS: [
    'GERENCIAR_PROCESSOS',
    'LISTAR_PROCESSOS',
    'LIST_PROCESS',
    'MODELADOR',
  ].map((alias) => normalizePermissionName(alias)),
  EXECUTAR_PROCESSOS: [
    'EXECUTAR_PROCESSOS',
    'EXECUTE_PROCESS',
    'GERENCIAR_PROCESSOS',
  ],
  MODELADOR: ['MODELADOR', 'CREATE_PROCESS'],
  ATUALIZAR_PROCESSOS: [
    'ATUALIZAR_PROCESSOS',
    'UPDATE_PROCESS',
    'GERENCIAR_PROCESSOS',
  ],
  BAIXAR_PROCESSOS: [
    'BAIXAR_PROCESSOS',
    'DOWNLOAD_PROCESS',
    'GERENCIAR_PROCESSOS',
  ],
  EXCLUIR_PROCESSOS: [
    'EXCLUIR_PROCESSOS',
    'DELETE_PROCESS',
    'GERENCIAR_PROCESSOS',
  ],
  LISTAR_FORMULARIOS: ['LISTAR_FORMULARIOS', 'LIST_FORM', ...FORM_MANAGER_ALIASES],
  CRIAR_FORMULARIOS: ['CRIAR_FORMULARIOS', 'CREATE_FORM', ...FORM_MANAGER_ALIASES],
  ATUALIZAR_FORMULARIOS: ['ATUALIZAR_FORMULARIOS', 'UPDATE_FORM', ...FORM_MANAGER_ALIASES],
  EXCLUIR_FORMULARIOS: ['EXCLUIR_FORMULARIOS', 'DELETE_FORM', ...FORM_MANAGER_ALIASES],
  LISTAR_GRUPOS: ['LISTAR_GRUPOS', 'LIST_GROUP'],
  CRIAR_GRUPOS: ['CRIAR_GRUPOS', 'CREATE_GROUP'],
  ATUALIZAR_GRUPOS: ['ATUALIZAR_GRUPOS', 'UPDATE_GROUP'],
  EXCLUIR_GRUPOS: ['EXCLUIR_GRUPOS', 'DELETE_GROUP'],
  LISTAR_PERMISSOES: ['LISTAR_PERMISSOES', 'LIST_PERMISSION'],
  CRIAR_PERMISSOES: ['CRIAR_PERMISSOES', 'CREATE_PERMISSION'],
  ATUALIZAR_PERMISSOES: ['ATUALIZAR_PERMISSOES', 'UPDATE_PERMISSION'],
  EXCLUIR_PERMISSOES: ['EXCLUIR_PERMISSOES', 'DELETE_PERMISSION'],
  LISTAR_USUARIOS: ['LISTAR_USUARIOS', 'LIST_USER'],
  CRIAR_USUARIOS: ['CRIAR_USUARIOS', 'CREATE_USER'],
  ATUALIZAR_USUARIOS: ['ATUALIZAR_USUARIOS', 'UPDATE_USER'],
  EXCLUIR_USUARIOS: ['EXCLUIR_USUARIOS', 'DELETE_USER'],
  CRIAR_AVISOS_MURAL: ['CRIAR_AVISOS_MURAL', 'CREATE_NOTICE_BOARD_POST', 'MANAGE_NOTICE_BOARD'],
  ATUALIZAR_AVISOS_MURAL: ['ATUALIZAR_AVISOS_MURAL', 'UPDATE_NOTICE_BOARD_POST', 'MANAGE_NOTICE_BOARD'],
  EXCLUIR_AVISOS_MURAL: ['EXCLUIR_AVISOS_MURAL', 'DELETE_NOTICE_BOARD_POST', 'MANAGE_NOTICE_BOARD'],
  COMPARTILHAR_EVENTOS: ['COMPARTILHAR_EVENTOS', 'SHARE_CALENDAR_EVENTS'],
  ...MENU_PERMISSION_ALIASES,
};

const SELF_SERVICE_ALIASES = new Set(
  [
    'EXECUTAR_PROCESSOS',
    'EXECUTE_PROCESS',
    'LISTAR_PROCESSOS',
    'LIST_PROCESS',
    'LISTAR_FORMULARIOS',
    'LIST_FORM',
  ].map((alias) => normalizePermissionName(alias)),
);

const LABEL_OVERRIDES = {
  GERENCIAR_FORMULARIOS: 'Gerenciar formulários',
  GERENCIAR_CADASTROS: 'Gerenciar cadastros',
  VISUALIZAR_CADASTROS: 'Visualizar cadastros',
  GERENCIAR_PROCESSOS: 'Gerenciar processos',
  GERENCIAR_ARQUIVOS: 'Gerenciar arquivos',
  GERENCIAR_EMPRESA: 'Gerenciar empresa',
  GERENCIAR_FINANCEIRO: 'Gerenciar financeiro',
  VISUALIZAR_FINANCEIRO: 'Visualizar financeiro',
  GERENCIAR_ESTOQUE: 'Gerenciar estoque',
  VISUALIZAR_ESTOQUE: 'Visualizar estoque',
  GERENCIAR_CRM: 'Gerenciar CRM',
  VISUALIZAR_CRM: 'Visualizar CRM',
  GERENCIAR_PATRIMONIO: 'Gerenciar patrimônio',
  VISUALIZAR_PATRIMONIO: 'Visualizar patrimônio',
  GERENCIAR_RECURSOS_HUMANOS: 'Gerenciar recursos humanos',
  VISUALIZAR_RECURSOS_HUMANOS: 'Visualizar recursos humanos',
  MODELADOR: 'Modelador',
  COMPARTILHAR_EVENTOS: 'Compartilhar eventos',
  VISUALIZAR_MENU_DASHBOARD: 'Visualizar menu Dashboard',
  VISUALIZAR_MENU_STUDIO: 'Visualizar menu Studio',
  VISUALIZAR_MENU_AUTOMACOES: 'Visualizar menu Automações',
  VISUALIZAR_MENU_SOLICITACOES: 'Visualizar menu Minhas solicitações',
  VISUALIZAR_MENU_ASSISTENTE_IA: 'Visualizar menu Assistente IA',
  VISUALIZAR_MENU_FORMULARIOS: 'Visualizar menu Formulários',
  VISUALIZAR_MENU_PROCESSOS: 'Visualizar menu Processos',
  VISUALIZAR_MENU_ARQUIVOS: 'Visualizar menu Arquivos',
  VISUALIZAR_MENU_AGENDA: 'Visualizar menu Agenda',
  VISUALIZAR_MENU_NEGOCIO: 'Visualizar menu Meu Negócio',
  VISUALIZAR_MENU_CRM: 'Visualizar menu CRM',
  VISUALIZAR_MENU_CONFIGURACOES: 'Visualizar menu Configurações',
  VISUALIZAR_MENU_CADASTROS: 'Visualizar menu Central de Cadastros',
  VISUALIZAR_MENU_DADOS_CADASTRAIS: 'Visualizar menu Dados Cadastrais',
  VISUALIZAR_MENU_FINANCEIRO: 'Visualizar menu Financeiro',
  VISUALIZAR_MENU_ESTOQUE: 'Visualizar menu Estoque',
  VISUALIZAR_MENU_PATRIMONIO: 'Visualizar menu Patrimônio',
  VISUALIZAR_MENU_RECURSOS_HUMANOS: 'Visualizar menu Recursos Humanos',
  VISUALIZAR_MENU_ORGANOGRAMA: 'Visualizar menu Organograma',
  VISUALIZAR_MENU_GRUPOS: 'Visualizar menu Grupos',
  VISUALIZAR_MENU_USUARIOS: 'Visualizar menu Usuários',
  VISUALIZAR_MENU_AUDITORIA: 'Visualizar menu Auditoria',
  VISUALIZAR_MENU_EMAIL: 'Visualizar menu E-mail',
  VISUALIZAR_MENU_MANUAL_DO_USUARIO: 'Visualizar menu Manual do usuário',
  VISUALIZAR_MENU_PERFIL: 'Visualizar menu Perfil',
  VISUALIZAR_MENU_MINHA_EQUIPE: 'Visualizar menu Minha equipe',
  VISUALIZAR_MENU_LIXEIRA: 'Visualizar menu Lixeira',
};

const capitalize = (text) =>
  text
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const getPermissionAliases = (permissionName) => {
  const normalizedName = normalizePermissionName(permissionName);
  const matchingEntries = Object.entries(PERMISSION_ALIASES).filter(
    ([key, aliases]) =>
      normalizePermissionName(key) === normalizedName ||
      aliases.some((alias) => normalizePermissionName(alias) === normalizedName),
  );

  if (matchingEntries.length > 0) {
    const aliasSet = new Set();
    matchingEntries.forEach(([key]) => {
      aliasSet.add(key);
      PERMISSION_ALIASES[key].forEach((alias) => aliasSet.add(alias));
    });
    return Array.from(aliasSet);
  }

  const fallback =
    PERMISSION_ALIASES[permissionName] ||
    PERMISSION_ALIASES[normalizedName] ||
    [permissionName];
  return Array.from(new Set(fallback));
};

export const hasPermission = (user, permissionName) => {
  if (!user?.group?.permissions) return false;
  const userPermissions = new Set(
    user.group.permissions.map((perm) => normalizePermissionName(perm.name)),
  );
  return getPermissionAliases(permissionName)
    .map((alias) => normalizePermissionName(alias))
    .some((alias) => userPermissions.has(alias));
};

export const isAdmin = (user) => hasPermission(user, 'ADMINISTRADOR');

export const hasAnyPermission = (user) =>
  Array.isArray(user?.group?.permissions) && user.group.permissions.length > 0;

export const canAccessWithoutPermission = (user, permissionName) => {
  if (!hasAnyPermission(user)) {
    return getPermissionAliases(permissionName)
      .map((alias) => normalizePermissionName(alias))
      .some((alias) => SELF_SERVICE_ALIASES.has(alias));
  }
  return false;
};

export const formatPermissionName = (permissionName) => {
  const normalizedName = normalizePermissionName(permissionName);
  const directKeyEntry = Object.keys(PERMISSION_ALIASES).find(
    (key) => normalizePermissionName(key) === normalizedName
  );
  const aliasEntry =
    directKeyEntry ||
    Object.entries(PERMISSION_ALIASES).find(([, aliases]) =>
      aliases.some((alias) => normalizePermissionName(alias) === normalizedName)
    )?.[0];
  const baseName = aliasEntry || normalizedName;
  if (LABEL_OVERRIDES[baseName]) {
    return LABEL_OVERRIDES[baseName];
  }
  return capitalize(baseName);
};

export const ADMIN_PERMISSION = 'ADMINISTRADOR';
export const MODELER_PERMISSION = 'MODELADOR';
export const PROCESS_MANAGER_PERMISSION = 'GERENCIAR_PROCESSOS';
export const FILE_MANAGER_PERMISSION = 'GERENCIAR_ARQUIVOS';
export const FORM_MANAGER_PERMISSION = 'GERENCIAR_FORMULARIOS';
export const COMPANY_MANAGER_PERMISSION = 'GERENCIAR_EMPRESA';
export const FINANCE_MANAGE_PERMISSION = 'GERENCIAR_FINANCEIRO';
export const FINANCE_VIEW_PERMISSION = 'VISUALIZAR_FINANCEIRO';
export const INVENTORY_MANAGE_PERMISSION = 'GERENCIAR_ESTOQUE';
export const INVENTORY_VIEW_PERMISSION = 'VISUALIZAR_ESTOQUE';
export const CRM_MANAGE_PERMISSION = 'GERENCIAR_CRM';
export const CRM_VIEW_PERMISSION = 'VISUALIZAR_CRM';
export const ASSET_MANAGE_PERMISSION = 'GERENCIAR_PATRIMONIO';
export const ASSET_VIEW_PERMISSION = 'VISUALIZAR_PATRIMONIO';
export const HUMAN_RESOURCES_MANAGE_PERMISSION = 'GERENCIAR_RECURSOS_HUMANOS';
export const HUMAN_RESOURCES_VIEW_PERMISSION = 'VISUALIZAR_RECURSOS_HUMANOS';
export const PROCESS_UPDATE_PERMISSION = 'ATUALIZAR_PROCESSOS';
export const PROCESS_DELETE_PERMISSION = 'EXCLUIR_PROCESSOS';
export const PROCESS_EXECUTE_PERMISSION = 'EXECUTAR_PROCESSOS';
export const REGISTRATION_MANAGE_PERMISSION = 'GERENCIAR_CADASTROS';
export const REGISTRATION_VIEW_PERMISSION = 'VISUALIZAR_CADASTROS';
export const FORM_CREATE_PERMISSION = 'CRIAR_FORMULARIOS';
export const FORM_UPDATE_PERMISSION = 'ATUALIZAR_FORMULARIOS';
export const FORM_DELETE_PERMISSION = 'EXCLUIR_FORMULARIOS';
export const MURAL_CREATE_PERMISSION = 'CRIAR_AVISOS_MURAL';
export const MURAL_UPDATE_PERMISSION = 'ATUALIZAR_AVISOS_MURAL';
export const MURAL_DELETE_PERMISSION = 'EXCLUIR_AVISOS_MURAL';
export const CALENDAR_SHARE_PERMISSION = 'COMPARTILHAR_EVENTOS';
export const DASHBOARD_MENU_PERMISSION = 'VISUALIZAR_MENU_DASHBOARD';
export const AUTOMATION_MENU_PERMISSION = 'VISUALIZAR_MENU_AUTOMACOES';
export const STUDIO_MENU_PERMISSION = 'VISUALIZAR_MENU_STUDIO';
export const COURSES_MENU_PERMISSION = 'VISUALIZAR_MENU_CURSOS';
export const COURSES_VIEW_PERMISSION = 'VISUALIZAR_CURSOS';
export const COURSE_EDITOR_VIEW_PERMISSION = 'VISUALIZAR_EDICAO_CURSOS';
export const CONTENT_CREATOR_PERMISSION = 'CRIADOR_DE_CONTEUDO';
export const COURSE_COORDINATOR_PERMISSION = 'COORDENADOR_DE_CURSOS';
export const COURSE_CLASS_MANAGER_PERMISSION = 'GERENCIAR_TURMAS';
export const STUDIO_ASSISTANT_MENU_PERMISSION = 'VISUALIZAR_MENU_ASSISTENTE_IA';
export const STUDIO_FORMS_MENU_PERMISSION = 'VISUALIZAR_MENU_FORMULARIOS';
export const STUDIO_PROCESSES_MENU_PERMISSION = 'VISUALIZAR_MENU_PROCESSOS';
export const FILE_MANAGER_MENU_PERMISSION = 'VISUALIZAR_MENU_ARQUIVOS';
export const AGENDA_MENU_PERMISSION = 'VISUALIZAR_MENU_AGENDA';
export const BUSINESS_MENU_PERMISSION = 'VISUALIZAR_MENU_NEGOCIO';
export const REGISTRATION_MENU_PERMISSION = 'VISUALIZAR_MENU_CADASTROS';
export const REQUESTS_MENU_PERMISSION = 'VISUALIZAR_MENU_SOLICITACOES';
export const SETTINGS_MENU_PERMISSION = 'VISUALIZAR_MENU_CONFIGURACOES';
export const BUSINESS_COMPANY_MENU_PERMISSION = 'VISUALIZAR_MENU_DADOS_CADASTRAIS';
export const BUSINESS_FINANCE_MENU_PERMISSION = 'VISUALIZAR_MENU_FINANCEIRO';
export const BUSINESS_INVENTORY_MENU_PERMISSION = 'VISUALIZAR_MENU_ESTOQUE';
export const BUSINESS_ASSET_MENU_PERMISSION = 'VISUALIZAR_MENU_PATRIMONIO';
export const BUSINESS_CRM_MENU_PERMISSION = 'VISUALIZAR_MENU_CRM';
export const BUSINESS_HR_MENU_PERMISSION = 'VISUALIZAR_MENU_RECURSOS_HUMANOS';
export const BUSINESS_ORG_CHART_MENU_PERMISSION = 'VISUALIZAR_MENU_ORGANOGRAMA';
export const TRASH_MENU_PERMISSION = 'VISUALIZAR_MENU_LIXEIRA';
export const SETTINGS_GROUPS_MENU_PERMISSION = 'VISUALIZAR_MENU_GRUPOS';
export const SETTINGS_USERS_MENU_PERMISSION = 'VISUALIZAR_MENU_USUARIOS';
export const SETTINGS_AUDIT_MENU_PERMISSION = 'VISUALIZAR_MENU_AUDITORIA';
export const SETTINGS_MAIL_MENU_PERMISSION = 'VISUALIZAR_MENU_EMAIL';
export const SETTINGS_USER_MANUAL_MENU_PERMISSION = 'VISUALIZAR_MENU_MANUAL_DO_USUARIO';
export const SETTINGS_PROFILE_MENU_PERMISSION = 'VISUALIZAR_MENU_PERFIL';
export const SETTINGS_MY_TEAM_MENU_PERMISSION = 'VISUALIZAR_MENU_MINHA_EQUIPE';

export const TRASH_MANAGER_PERMISSIONS = [
  PROCESS_MANAGER_PERMISSION,
  FORM_MANAGER_PERMISSION,
  FILE_MANAGER_PERMISSION,
];

export const canManageTrash = (user) => {
  if (isAdmin(user)) {
    return true;
  }

  if (!hasPermission(user, TRASH_MENU_PERMISSION)) {
    return false;
  }

  return TRASH_MANAGER_PERMISSIONS.some((permission) => hasPermission(user, permission));
};
